import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/static/icon.png'


const _hoisted_1 = { class: "nav-section" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: "",
  class: "pic"
}

import { getCurrentInstance } from "vue"
	import { useModuleMapState } from '@/config/useMapState'
	import { useStore } from 'vuex'
	import { localDel } from '@/config/storage'
	import { signOut } from '@/request/api/auth'
	
	
export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

	const {commit} = useStore()
	
	const { isCollapse, account, avatar } = useModuleMapState('publicOptions', ['isCollapse', 'account', 'avatar'])
	const collapseClick = (state:string) => {
		switch (state) {
			case 'open':
				commit("publicOptions/MENU_COLLAPSE", true)
		    break
			case 'close':
				commit("publicOptions/MENU_COLLAPSE", false)
		    break
		}
	}
	const {$confirm, $message, $router} = getCurrentInstance().appContext.config.globalProperties
	const toLogout = () => {
		$confirm('是否退出登录?', '系统提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
		  try {
		    const { code, message } = await signOut()
		    if (code === 200) {
		      $message.success(message)
		      commit("publicOptions/SAVE_TOKEN", '') //删除vuex中的token
		      localDel('token')
			  commit("publicOptions/SAVE_AVATAR", '') //删除vuex中的token
			  localDel('avatar')
		      $router.replace('/login')
		    }
		  } catch (error) {
		    console.log(error)
		  }
		}).catch(() => {
			
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "nav",
      justify: "space-between",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isCollapse))
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (collapseClick('close')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Fold)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (collapseClick('open')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Expand)
                ]),
                _: 1
              }))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "yddbtn pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref($router).push('/personal')))
          }, [
            (_unref(avatar) && _unref(avatar) != null)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(avatar),
                  alt: "",
                  class: "pic"
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
            _createTextVNode(" " + _toDisplayString(_unref(account)), 1)
          ]),
          _createElementVNode("div", {
            class: "yddbtn pointer",
            onClick: toLogout
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_SwitchButton)
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createTextVNode("退出 "))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})